import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './InventoryCounts.frontend.types'

@Injectable({ providedIn: 'root' })
export class InventoryCounts_create_inventory_count_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { lookupCode?: string, warehouseId: number, locationFilter?: { locationIds?: number[], includeEmptyLocations?: boolean, onlyEmptyLocations?: boolean, skipHardAllocationLocations?: boolean, skipLocationsWithReleasedCountTask?: boolean }, materialFilter_ownerId?: number, materialFilter_projectId?: number, materialFilter_materialIds?: number[], materialFilter_vendorLotIds?: number[] }): Promise<{ inventoryCountId?: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

